export const liveSearch = {
  SUBMIT: 'liveSearch.Submit'
}
